import React from 'react';
import PropTypes from 'prop-types';
import Awards from './Awards/Awards';
import './Hero.css';

const Hero = ({ isDesktop , buttons }) => {    
    return (
        <section className="hero">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-multiline is-vcentered">
                        <div className="column is-offset-1-tablet is-10-tablet is-7-desktop">
                            <div className="title-wrapper animated fadeInLeft">
                                <h1 className="hidden">Hudson Pacific Properties Social Responsibilities</h1>
                                <div className="pre-title">SUSTAINABILITY </div>
                                <div className="big-title">
                                    CREATING A BETTER BLUEPRINT FOR THE BUILT ENVIRONMENT   
                                </div>

                                <div className="hero-desc">
                                    {/* UPDATE BOTH OF THESE WITH THE SAME COPY */}
                                    <div className="is-hidden-desktop">
                                    Better Blueprint™ brings to life our vision of vibrant, thriving urban spaces and places built for the long term. This ‘blueprint’ is integral to our business model and articulates many of the principles and practices that underly both our portfolio and management excellence, and guide our work with all stakeholders integral to our success: our tenants, employees, investors and partners. 
                                    </div>
                                    <div className="is-hidden-touch">
                                        <p>
                                        Better Blueprint™ brings to life our vision of vibrant, thriving urban spaces and places built for the long term. This ‘blueprint’ is integral to our business model and articulates many of the principles and practices that underly both our portfolio and management excellence, and guide our work with all stakeholders integral to our success: our tenants, employees, investors and partners.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="column is-offset-1-tablet is-offset-0-desktop is-12-mobile is-6-tablet is-4-desktop flex-end"></div>
                    </div>

                    <div className="columns">
                        {/* Column sizing for desktop here is hacky for centering the buttons. I don't like it but at least don't hate myself for it.  -Jhony */}
                        <div className="column is-offset-1-tablet is-10-tablet is-9-desktop">
                            <div className="cta-wrapper animated fadeInLeft">
                                {buttons.corporate_responsability_report && <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`button ${isDesktop ? 'animated fadeInRight' : ''}`}
                                    href={`${buttons.corporate_responsability_report}`}
                                >
                                    <span>BETTER BLUEPRINT REPORT</span>
                                </a>}
                                {buttons.green_finance_framework_spo && <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`button ${isDesktop ? 'animated fadeInRight' : ''}`}
                                    href={`${buttons.green_finance_framework_spo}`}
                                >
                                    <span>&nbsp;&nbsp; Green Finance &nbsp;&nbsp;</span>
                                </a>}
                                {/* {buttons.green_finance_framework && <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`button ${isDesktop ? 'animated fadeInRight' : ''}`}
                                    href={`${buttons.green_finance_framework}`}
                                >
                                    <span>&nbsp;&nbsp; Green Finance Framework &nbsp;&nbsp;</span>
                                </a>} */}
                            </div>
                        </div>
                    </div>
                
                    <Awards/>
                </div>
            </div>
        </section>
    );
};

Hero.propTypes = {
    isDesktop: PropTypes.bool,
    buttons: PropTypes.shape({
        corporate_responsability_report: PropTypes.string,
        green_finance_framework_spo: PropTypes.string,
    }),
};

export default Hero;
